const SIZES = {
  // avatar sizes
  avatar_xsm: "w_100,h_100,c_fill",
  avatar_sm: "w_200,h_200,c_fill",
  avatar_md: "w_400,h_400,c_fill",
  avatar_lg: "w_800,h_800,c_fill",

  // service requests sizing

  srv_sm: "w_200,h_150,c_fill",
  srv_med: "w_400,h_267,c_fill",

  // job images for freelancer or businesses for their profile
  job_sm: "w_400,h_400,c_fill",
  job_med: "w_500,h_500,c_fill"
};

export const getImage = (url, size = "avatar_sm") => {
  if (!url) return null;

  const transform = SIZES[size];
  if (!transform) return url;

  return url.replace("/upload/", `/upload/${transform}/`);
};